import { enumToString } from "./enums";

export enum Environments {
  None,
  Local,
  Test,
  e2e,
  Dev,
  QA,
  UAT,
  Prod,
}

export class Environment {
  environment: Environments;

  constructor(env?: string | Environments) {
    if (typeof env === "number") {
      this.environment = env;
      return;
    }
    this.environment = this.parseEnv(env);
  }

  private parseEnv(env?: string): Environments {
    env = env?.toLowerCase();

    if (env === "local") return Environments.Local;
    else if (env === "dev" || env === "development") return Environments.Dev;
    else if (env === "e2e") return Environments.e2e;
    else if (env === "test") return Environments.Test;
    else if (env === "qa") return Environments.QA;
    else if (env === "uat") return Environments.UAT;
    else if (env === "prod" || env === "production") return Environments.Prod;
    else {
      throw Error(`Unknown environment: ${env}`);
    }
  }

  public getEnv(): Environments {
    if (this.environment === undefined) throw Error(`Environment not set: ${this.environment}`);
    return this.environment;
  }

  public getName(): string {
    return enumToString(Environments, this.getEnv())!;
  }

  public isLocal = (): boolean => this.getEnv() === Environments.Local;
  public isE2e = (): boolean => this.getEnv() === Environments.e2e;
  public isDev = (): boolean => this.getEnv() === Environments.Dev;
  public isTest = (): boolean => this.getEnv() === Environments.Test;
  public isQa = (): boolean => this.getEnv() === Environments.QA;
  public isUat = (): boolean => this.getEnv() === Environments.UAT;
  public isProd = (): boolean => this.getEnv() === Environments.Prod;

  // To prevent test code running in PROD
  public assetTest = (): void => {
    if (!this.isLocal() && !this.isE2e() && !this.isDev() && !this.isTest()) {
      throw Error(`Invalid environment - not test: ${this.environment}`);
    }
  };

  // To make sure its NOT prod
  public assertNotProd = (): void => {
    if (this.isProd()) {
      throw Error(`Invalid environment - shoult not be prod: ${this.environment}`);
    }
  };
}

// We needed a separate function to test the environment
// For the functions - pass in isTestEnv(process.env)
export function isTestEnv(env: any): boolean {
  return env.ENV === "TEST";
}

export function isDevEnv(env: any): boolean {
  return env.ENV === "LOCAL" || env.ENV === "DEV";
}

// TODO: Why do we want this!?
export function initialiseEnvironment(env: string | undefined): Environment {
  return new Environment(env);
}
